import { addProtocol } from "maplibre-gl";
import "~/css/style.css";
import { Map, Marker } from "~/ui";
import {
    DirectionControl,
    FullscreenControl, GeocoderControl, GeolocateControl, LayersControl,
    LogoControl, NavigationControl, RotateControl,
    RoutingControl,
    RulerControl,
    ScaleControl,
    StreetViewControl, StyleControl, TrafficControl, TruckRestrictionsControl
} from "~/ui/control";
import { Circle, Polygon, Polyline, Rectangle } from "~/ui/shapes";
import { normalizeProtocol } from "~/utils";
import { makeNMapsRequest } from "./api";

var config = {
    "API_URL": "",
    "ACCESS_TOKEN": "",
}

function getAccessToken(): string | undefined {
    return config.ACCESS_TOKEN;
}

function setAccessToken(value: string) {
    config.ACCESS_TOKEN = value;
}

function getApiUrl(): string {
    return config.API_URL || "https://nmaps.ndrive.com/api";
}

function setApiUrl(value: string) {
    config.API_URL = value;
}

addProtocol("nmaps", (params, abortController) => {
    const isJSON = params.url.endsWith(".json");
    const isLocal = params.url.indexOf("127.0.0.1") > 0;
    const urlParts = params.url.split("://");
    if (urlParts.length > 2) {
        params.url = `http://${urlParts[ 2 ]}`;
    } else {
        if (isLocal){
            params.url = `http://${urlParts[ 1 ]}`;
        }else{
            params.url = `https://${urlParts[ 1 ]}`;
        }
    }

    return makeNMapsRequest(params, abortController)
        .then((res) => {
            if (isJSON) res.data = normalizeProtocol(res.data);
            return res;
        });
});

export {
    addProtocol, addSourceType, AJAXError, AttributionControl, BoxZoomHandler, CanvasSource, clearPrewarmedResources, CooperativeGesturesHandler, DoubleClickZoomHandler, DragPanHandler, DragRotateHandler, EdgeInsets, Evented, GeoJSONSource, getMaxParallelImageRequests, getRTLTextPluginStatus, getVersion, getWorkerCount, getWorkerUrl, Hash, ImageSource, importScriptInWorkers, KeyboardHandler, LngLat, LngLatBounds, MapMouseEvent, MapTouchEvent, MapWheelEvent, MercatorCoordinate, Point, Popup, prewarm, RasterDEMTileSource, RasterTileSource, removeProtocol, ScrollZoomHandler, setMaxParallelImageRequests, setRTLTextPlugin, setWorkerCount, setWorkerUrl, Style, TerrainControl, TwoFingersTouchPitchHandler, TwoFingersTouchRotateHandler, TwoFingersTouchZoomHandler, TwoFingersTouchZoomRotateHandler, VectorTileSource, VideoSource
} from "maplibre-gl";

export {
    Circle, config, DirectionControl, FullscreenControl,
    GeocoderControl,
    GeolocateControl, getAccessToken,
    getApiUrl, LayersControl,
    LogoControl,
    Map,
    Marker,
    NavigationControl,
    Polygon,
    Polyline,
    Rectangle,
    RotateControl, RoutingControl, RulerControl, ScaleControl, setAccessToken,
    setApiUrl, StreetViewControl,
    StyleControl,
    TrafficControl,
    TruckRestrictionsControl
};
